<template lang="pug" functional>
  .planning-table-row-skeleton
    v-card.planning-table-row-skeleton__item(
      v-for="i in props.count"
      :key="i")
      .planning-table-row-skeleton__loader
      .planning-table-row-skeleton__loader
      .planning-table-row-skeleton__loader
      .planning-table-row-skeleton__loader
      .planning-table-row-skeleton__loader
      .planning-table-row-skeleton__loader
</template>

<script>
export default {
  name: 'PlanningTableRowSkeleton',

  props: {
    count: {
      type: Number,
      default: 7
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '@/sass/abstracts/_mixins.scss';

  .planning-table-row-skeleton {

    &__item {
      height: 4.5rem;
      margin-bottom: 1rem;
      padding: 1rem 1.5rem;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    &__loader {
      height: 2.5rem;
      width: 10rem;
      border-radius: .8rem;

      &:last-child {
        width: 11rem;
        margin-left: 13rem;
      }

      @include skeleton;
    }
  }
</style>
